"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAUNCHER_PARAM = void 0;
exports.addLauncherParam = addLauncherParam;
exports.LAUNCHER_PARAM = "from";
function addLauncherParam(href, launcher) {
    if (!launcher)
        return href;
    return `${href}${href.includes("?") ? "&" : "?"}${exports.LAUNCHER_PARAM}=${encodeURIComponent(launcher)}`;
}
